export default "__VITE_ASSET__ea1ade1f__"